import {genAppStoreUrl, genGooglePlayUrl, genGoogleAPKPlayUrl} from '@/helper/download';
import lang from '../../Header.lang';

export const getDownloadChannels = (language = 'en') => [
  {
    channelName: lang.AppStore,
    desc: lang.AppStoreGetDesc,
    icon: 'https://img.phemex.com/v1/667e0b0d-159b-4474-a587-6025056bdcb8/vector.svg',
    href: genAppStoreUrl(language),
  },
  {
    channelName: lang.GooglePlay,
    desc: lang.GooglePlayGetDesc,
    icon: 'https://img.phemex.com/v1/bee8e695-ecbe-4197-9ae9-b5b4d77c21de/home-download-google-play-svg.svg',
    href: genGooglePlayUrl(language),
  },
  {
    isSplit: true,
    channelName: lang.DownloadAPK,
    desc: null,
    icon: 'https://img.phemex.com/v1/d738042a-eb48-40f0-8389-0e8ec65f05b3/android-2.svg',
    href: genGoogleAPKPlayUrl(language),
  },
];
